import Vue from 'vue'
import axios from 'axios'
import AxiosConfig from './axios-config'
import qs from 'qs'
import router from '@/router'
import wx from 'weixin-js-sdk'

var AxiosSND = axios.create(AxiosConfig)
AxiosSND.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token') || ''
        const user_id = localStorage.getItem('user_id') || ''
        config.headers['x-token'] = token
        config.headers['Authorization'] = token
        config.headers['x-user-id'] = user_id
        return config
    },
    error => {
        return error
    }
)

// 全局配置，携带cookie信息
AxiosSND.defaults.withCredentials = false
//把封装的axios作为vue的插件使用
Object.defineProperties(Vue.prototype, {
    axios: {
        get() {
            return AxiosSND
        }
    },

    $http: {
        get() {
            return AxiosSND
        }
    }
})

const Types = [
    '', //0
    '观看课程', //1
    '浏览文章', //2
    '观看短视频', //3
    '观看直播', //4
    '会议直播', //5
    '病例实战', //6
    '临床技能培训', //7
    '科研能力培训', //8
    '下载资料', //9
    '学术研究', //10
    '活动管理', //11
    '', //12
    '专题', //13
    '大会', //14
    '浏览专题简介详情', //15
    '浏览专题专栏', //16
    '浏览专题详情', //17
    '浏览专题详情', //18
    '', //19
    '' //20
]

export default {
    api: 'https://byh-api.dr-gobroad.com',
    host: 'http://dr-yyh.com',
    web_host:"https://byh-pc.dr-gobroad.com",
    cf: 'https://conference-h5.dr-gobroad.com',
    home: '/course/api/homepage',
    channel: '/course/api/channel',
    channel_item: '/course/api/channel_item',
    banner: '/course/api/banner/list',
    category: '/course/api/category/list',
    video_info: '/course/api/video/info',
    comment: '/course/api/comment',
    pointLikeComment: '/course/api/comment/toggle/like/',
    footprint: '/user/api/footprint/record',
    amount_rule: '/user/api/point/rules',
    share: '/course/api/share',
    progress: '/course/api/course/record',
    search: '/course/api/search',
    wechat_share: '/wechat/jsSdk',
    uploadImg: '/course/upload/file',
    shareFootPrintUrl: '/course/api/share/record',
    exposureFootPrintUrl: '/course/api/exposure/record',
    pvPrintUrl: '/user/api/browsing/record',
    user: {
        login: '/user/oauth/sms/login',
        send_verify: '/user/api/sms/verify-code',
        check_verify: '/user/oauth/sms/verify-code/check',
        update_tel: '/user/api/change/mobile',
        position: '/user/api/position',
        title: '/user/api/titles',
        city: '/user/api/city',
        office: '/user/api/office',
        office_search: '/user/api/office/search',
        hospital: '/user/api/hospital',
        hospital_search: '/user/api/hospital/search',
        add_info: '/user/api/user/info',
        user_info: '/user/oauth/userinfo',
        openid_login: '/user/oauth/openid/login',
        unionid_login: '/user/oauth/unionid/login',
        uuid_login: '/user/oauth/uuid/login',
        history: '/user/api/footprint/list',
        favorite: '/user/api/favorite/list',
        focus: '/user/api/subscribe',
        appointment: '/user/api/appointment',
        point: '/user/api/point/list',
        tags: '/user/api/tags',
        org: '/user/api/organization_type',
        identity: '/user/api/identity',
        major: '/user/api/major',
        school: '/user/api/school',
        patient_tags: '/user/api/patient_tags',
    },

    meeting: {
        list: '/meeting/api/meeting',
        news: '/meeting/api/subject/news/'
    },

    course: {
        list: '/course/api/course/list',
        detail: '/course/api/course',

        category: '/course/api/category/list?type=1',

        comment: {
            store: '/course/api/comment',
            list: '/course/api/comment'
        },
        point_like: '/course/api/course/toggle/like/1',
        favorite: '/course/api/course/toggle/favorite/',
        pdf_download: '/course/api/course/download/1',
        column: {
            detail: '/course/api/course',
            pdf_download: '/course/api/courseItem/download/1'
        }
    },
    short_video: {
        category: '/course/api/category/list?type=3',
        list: '/course/api/video/list',
        detail: '/course/api/video/detail',
        point_like: '/course/api/video/toggle/like/',
        favorite: '/course/api/video/toggle/favorite/',
        comment: {
            store: '/course/api/video/comment',
            list: '/course/api/video/comment/list/1?limit=3&page=1'
        }
    },
    article: {
        list: '/course/api/article/list',
        detail: '/course/api/article/detail',
        favorite: '/course/api/article/toggle/favorite',
        point_like: '/course/api/article/toggle/like/',
        comment: {
            store: '/course/api/article/comment',
            list: '/course/api/article/comment/list/1'
        }
    },
    case: {
        list: '/course/api/case',
        category: '/course/api/category/list?type=6',
        detail: '/course/api/article/detail',
        favorite: '/course/api/article/toggle/favorite',
        comment: {
            store: '/course/api/article/comment',
            list: '/course/api/article/comment/list/1'
        }
    },
    clinic: {
        list: '/course/api/clinic?content_type=7',
        category: '/course/api/category/list?type=7'
    },
    scientific: {
        list: '/course/api/clinic?content_type=8',
        category: '/course/api/category/list?type=8'
    },
    activity: {
        list: '/course/api/activity',
        detail : '/course/api/activity/'
    },
    live: {
        home: '/live/api/homepage',
        reBack: '/live/api/live/backs',
        study: '/live/api/sciences',
        category: '/course/api/category/list?type=4',
        study_category: '/course/api/category/list?type=10',
        detail: '/live/api/live',
        subscribeItem: '/live/api/liveItems/subscribe/',
        view_count: '/live/api/live/view',
        favorite: '/live/api/liveItems/favorite/',
        appointment: '/live/api/liveItems/appointment/',
        record: '/live/api/live/record',
        check_password: '/live/api/liveItems/password',
        showDialog:"/live/api/liveltems/dialog/",
        column: {
            list: '/live/api/lives',
            detail: '/live/api/live/'
        }
    },
    download: {
        list: '/course/api/download',
        category: '/course/api/category/list?type=9',
        favorite: '/course/api/download/favorite/',
        email: '/course/api/download/email',
        detail: '/course/api/download',
        download: '/course/api/download/count'
    },

    topic: {
        list: '/meeting/api/subject',
        detail: '/meeting/api/subject/',
        column: '/course/api/subject',
        honor: '/meeting/api/subject/elegant',
        honor_banner: '/course/api/banner/elegant',
        honor_detail: '/meeting/api/subject/elegant/',
        column_category: '/course/api/category-subject/list',
        study_group_list: '/meeting/api/subject/group',
        study_group: '/meeting/api/subject/group/',
        study_group_member: '/meeting/api/subject/member/'
    },

    v4: {
        search_list: '/course/api/search_words',
        search_del: '/course/api/search_words/user',
        // 搜索分类列表
        searchClassify: '/course/api/content_relation/type',
        hot_click: '/course/api/hot_words',
        courser_banner: '/course/api/banner/list',
        // 临床好课-课程上新
        course_new: '/course/api/course_new/home',
        // 临床好课-推荐专栏
        course_recommend: '/course/api/course/list_column',
        // 课程上新页面
        course_list: '/course/api/course_new/list',
        // 频道列表
        channel: '/course/api/channel',
        // 首页频道内容
        channel_item: '/course/api/channel',
        // 内容精选和搜索结果都用此接口
        content_select: '/course/api/content_relation',
        // 关注/取消关注
        attation: '/course/api/medicalColumn/subscribe',
        // 首页直播预告
        live: '/live/api/living',
        // 首页直播预告一键预约
        apply: '/live/api/liveItems/appointment',
        // 学术会列表
        meeting_list: '/meeting/api/academic',
        // 金刚位-图文详情
        text_desc: '/course/api/position',
        // 增加搜索词记录
        search_record: '/course/api/search_words/record'
    },
    medical: {
        // 医学专栏列表
        list: '/course/api/medicalColumn',
        subscribe: '/course/api/medicalColumn/subscribe/',
        detailinfo: '/course/api/article/detail/',
        followList: '/course/api/article/itemList/',
        course_recommend: '/course/api/course/list_column',
        // 课程上新页面
        course_list: '/course/api/course_new/list'
    },
    // 获得数据
    getData: function(type, url, params) {
        var that = this
        var token = localStorage.getItem('access_token')
        let axios
        if ('get' == type) {
            axios = AxiosSND.get(url, {
                params: params
            })
        } else if ('post' == type) {
            axios = AxiosSND.post(url, qs.stringify(params))
        } else if ('postFile' == type) {
            axios = AxiosSND.post(url, params)
        } else if ('put' == type) {
            axios = AxiosSND.put(url, qs.stringify(params))
        } else if ('delete' == type) {
            axios = AxiosSND.delete(url, qs.stringify(params))
        }
        let promise = new Promise((resolve, reject) => {
            axios
                .then(response => {
                    if (200 == response.status) {
                        resolve(response.data)
                    } else if (403 == response.status) {
                        Vue.prototype.$message.error('未知错误！')
                    } else if (500 == response.status) {
                        console.log(response)
                        Vue.prototype.$message.error('未知错误！')
                    } else if (422 == response.status) {
                        console.log(response, 422)
                    } else {
                        Vue.prototype.$message.error('未知错误！')
                    }
                })
                .catch(error => {
                    console.log(error)

                    if (error.response.status == 401) {
                        Vue.prototype.$message.error('登录超时，请重新登录！')
                        router.push('/login')
                    } else if (error.request) {
                        if (error.request.status == 422 && error.request.response.indexOf('name') != -1) {
                            Vue.prototype.$message.error('项目名称已存在！')
                        } else {
                            Vue.prototype.$message.error('网络异常，请检查您的网络并刷新重试！')
                        }
                    } else {
                        Vue.prototype.$message.error('未知错误，请刷新重试！')
                    }
                })
        })
        return promise
    },

    //时间戳，在需要时间转换的时候可以直接调用
    getTime: function(time) {
        var newDate = new Date()
        newDate.setTime(time * 1000)
        Date.prototype.format = function(format) {
            var date = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes()
            }
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in date) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
                }
            }
            return format
        }
        return newDate.format('yyyy-MM-dd hh:mm')
    },
    //时间戳，在需要时间转换的时候可以直接调用 'yyyy-MM-dd hh:mm:ss'
    getSeconds: function(time, formatType = 'yyyy-MM-dd hh:mm') {
        var newDate = new Date()
        newDate.setTime(time * 1000)
        Date.prototype.format = function(format) {
            var date = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes(),
                's+': this.getSeconds()
            }
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in date) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
                }
            }
            return format
        }
        return newDate.format(formatType)
    },
    getDateTime: function(time, formatType) {
        var newDate = new Date()
        newDate.setTime(time * 1000)
        Date.prototype.format = function(format) {
            var date = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes()
            }
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in date) {
                if (new RegExp('(' + k + ')').test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length))
                }
            }
            return format
        }
        let formatStr = formatType ? formatType : 'yyyy-MM-dd'
        return newDate.format(formatStr)
    },
    GetQueryUrl: name => {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let r = window.location.search.substr(1).match(reg)
        if (r != null) {
            return unescape(r[2])
        } else {
            return ''
        }
    },
    setCookie: function(name, val, days) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + days)
        document.cookie = name + '=' + escape(val) + (days == null ? '' : ';expires=' + exdate.toGMTString())
    },
    getCookie: function(c_name) {
        if (document.cookie.length > 0) {
            var c_start = document.cookie.indexOf(c_name + '=')
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1
                var c_end = document.cookie.indexOf(';', c_start)
                if (c_end == -1) c_end = document.cookie.length
                return unescape(document.cookie.substring(c_start, c_end))
            }
        }
        return ''
    },
    deleteRepetionChar: function(arr) {
        //先判断输入进来的是数组对象还是字符串
        if (typeof arr == 'object') {
            var arr = arr
        } else if (typeof arr == 'string') {
            //字符串转为数组
            var arr = arr.split(',')
        }
        //存放不相同的数据
        var box = [] //存放去重数据
        var thisArr //当前的值arr[i]
        //遍历数组
        for (var i = 0; i < arr.length; i++) {
            thisArr = arr[i]
            //定义一个旗子，检查是不是有重复的字符
            var flag = true
            //遍历存放数据盒子，检查是否等于当前元素
            for (var j = 0; j < box.length; j++) {
                //如果值存在
                if (box[j] == thisArr) {
                    flag = false
                    break //结束for循环
                }
            }
            if (flag == false) {
                //continue返回执行函数而不压入数组
                continue
            }
            box.push(thisArr)
        }
        return box
    },
    cloneObj: function(obj) {
        let str,
            newobj = obj.constructor === Array ? [] : {}
        if (typeof obj !== 'object') {
            return
        } else if (window.JSON) {
            ;(str = JSON.stringify(obj)), //系列化对象
                (newobj = JSON.parse(str)) //还原
        } else {
            for (let i in obj) {
                newobj[i] = typeof obj[i] === 'object' ? cloneObj(obj[i]) : obj[i]
            }
        }
        return newobj
    },
    destroy: function(url, callback) {
        Vue.prototype
            .$confirm('确认删除吗', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
            .then(() => {
                let params = {
                    _method: 'delete'
                }
                this.getData('post', url, params).then(res => {
                    if (res.data.code == 200) {
                        Vue.prototype.$message.success('删除成功')
                        callback(res.data.code)
                    } else {
                        Vue.prototype.$message.error(res.data.message)
                    }
                })
            })
    },

    getShareBaseInfo(_this, title, img, desc, debug = false, flag = true, type) {
        let Interface = this
        let url = window.location.href
        var params = {
            uri: encodeURI(url)
        }
        if (debug) {
            alert(url)
        }

        if (flag) {
            title = title === '' ? '博医荟' : title + '—博医荟'
        } else {
            title = title === '' ? '博医荟' : title
        }
        desc = desc == '' || desc == '<p><br></p>' ? '一站式垂直医生社区，学术会议·指南文献·医学资讯·实用工具' : desc
        img = Interface.host + '/static/share_logo.jpg'

        Interface.setDocumentTitle(title)
        Interface.getData('get', Interface.wechat_share, params).then(res => {
            wx.config({
                debug: debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.app_id, // 必填，公众号的唯一标识，填自己的！
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'chooseImage',
                    'previewImage',
                    'updateAppMessageShareData',
                    'updateTimelineShareData'
                ],
                openTagList: ['wx-open-launch-weapp']
            })

            wx.ready(() => {
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: img, // 分享图标
                    success: function() {}
                })

                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: img, // 分享图标
                    success: function() {
                        // 设置成功
                    }
                })
                //转发到朋友圈
                wx.onMenuShareTimeline({
                    title: title, // 转发时的标题
                    link: url, // 转发时的链接
                    imgUrl: img, // 转发时的图标
                    success: function() {},
                    cancel: function() {}
                })

                //转发给朋友
                wx.onMenuShareAppMessage({
                    title: title,
                    desc: desc,
                    link: url,
                    imgUrl: img,
                    type: '',
                    dataUrl: '',
                    success: function() {},
                    cancel: function() {}
                })
            })
        })
    },
    goLiveDetail(_this, item) {
        if (item.type === 2) {
            _this.$router.push({ name: 'live-column', params: { id: item.id } })
        } else if (item.live_status === 6) {
            _this.$router.push({ name: 'live-detail-home', params: { id: item.id } })
        } else {
            if (item.live_status === 0) {
                if (item.isAppointment) {
                    //预约过
                    _this.$router.push({ name: 'live-detail-home', params: { id: item.id } })
                } else {
                    _this.$router.push({ name: 'live-detail', params: { id: item.id } })
                }
            } else {
                _this.$router.push({ name: 'live-detail-home', params: { id: item.id } })
            }
        }
    },
    goTopic(_this, item) {
        _this.$router.push({ name: 'topic-detail', params: { id: item.id } })
    },
    getShareInfo(_this, title = '', img = '', desc = '', type, id = '',uri = '', debug = false, options = {}) {
        let Interface = this
        let url = window.location.href + '?source_type=1'
        if (debug) {
            alert(url)
        }

        if (options.isTopic) {
            title = title === '' ? '博医荟' : title
        }else{
            title = title === '' ? '博医荟' : title + '—博医荟'
        }


        desc = desc == '' || desc == '<p><br></p>' ? '一站式垂直医生社区，学术会议·指南文献·医学资讯·实用工具' : desc
        img = 'https://byh.dr-gobroad.com/static/share_logo.jpg'

        Interface.setDocumentTitle(title)
        Interface.getData('get', Interface.wechat_share, {
            uri: encodeURI(window.location.href)
        }).then(res => {
            wx.config({
                debug: debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.app_id, // 必填，公众号的唯一标识，填自己的！
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'chooseImage',
                    'previewImage',
                    'updateAppMessageShareData',
                    'updateTimelineShareData'
                ],
                openTagList: ['wx-open-launch-weapp']
            })

            wx.ready(() => {
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: img, // 分享图标
                    success: function() {}
                })

                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: img, // 分享图标
                    success: function() {
                        // 设置成功
                    }
                })
                //转发到朋友圈
                wx.onMenuShareTimeline({
                    title: title, // 转发时的标题
                    link: url, // 转发时的链接
                    imgUrl: img, // 转发时的图标
                    success: function() {},
                    cancel: function() {}
                })

                //转发给朋友
                wx.onMenuShareAppMessage({
                    title: title,
                    desc: desc,
                    link: url,
                    imgUrl: img,
                    type: '',
                    dataUrl: '',
                    success: function() {},
                    cancel: function() {}
                })
            })
            this.shareFootPrint(title,type,id)
        })
    },
    logout() {
        let Interface = this
        let url = window.location.href
        var params = {
            uri: encodeURI(url)
        }
        Interface.getData('get', Interface.wechat_share, params).then(res => {
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.data.app_id, // 必填，公众号的唯一标识，填自己的！
                timestamp: res.data.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
                nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
                signature: res.data.signature, // 必填，签名，见附录1
                jsApiList: ['closeWindow']
            })

            wx.ready(function() {
                //分享到朋友圈
                wx.closeWindow()
            })
        })
    },
    setDocumentTitle(title) {
        document.title = title
        if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
            var i = document.createElement('iframe')
            i.src = 'https://bytx.care-gobroad.com/static/bytx/home_head_1_icon.svg'
            i.style.display = 'none'
            i.onload = function() {
                setTimeout(function() {
                    i.remove()
                }, 9)
            }
            document.body.appendChild(i)
        }
    },
    footPrint(type, id = 0, content_type = 0, note = '') {
        let params = {
            id: id,
            type: type,
            content_type: content_type,
            note: note == '' ? Types[type] : note
        }
        this.getData('post', this.footprint, params)
    },

    goArticle(_this, item, from_content) {
        if (item.ctype == 2) {
            window.location.href = item.target_url
            return
        }

        let id = item.id
        if (from_content) {
            id = item.content_id
        }
        let path = {
            name: 'article-detail',
            params: { id: id },
            query: {}
        }

        if (item.type == 2) {
            path.name = 'article-column'
        }

        if (item.content_type > 0) {
            path.content_type = item.content_type
        }

        // console.log(path)
        _this.$router.push(path)
    },

    goMedicalColumn(_this, item) {
        let path = 'article-detail'
        if (item.ctype == 2) {
            window.location.href = item.target_url
            return
        } else if (item.type == 2) {
            path = 'medical-column-list'
        } else {
        }
        let params = {
            name: path,
            params: { id: item.id },
            query: {}
        }
        _this.$router.push(params)
    },
    goVideo(_this, item, from_content) {
        let id = item.id
        if (from_content) {
            id = item.content_id
        }
        let path = {
            name: 'video-detail',
            params: { id: id },
            query: {}
        }
        if (item.type == 2) {
            path.name = 'video-column'
        }
        if (item.content_type > 0) {
            path.content_type = item.content_type
        }
        _this.$router.push(path)
    },
    goCourse(_this, item, from_content) {
        let id = item.id
        if (from_content) {
            id = item.content_id
        }
        let path = {
            name: 'course-detail',
            params: { id: id },
            query: {}
        }
        if (item.type == 2) {
            path.name = 'course-column'
        }
        if (item.content_type > 0) {
            path.content_type = item.content_type
        }

        _this.$router.push(path)
    },
    goMeeting(_this, item) {
        if (item.is_saas == 2) {
            location.href = 'https://conference-h5.dr-gobroad.com/#/r?m=' + item.uuid
        } else {
            if (item.type == 1) {
                window.location.href = 'https://conference-h5.dr-gobroad.com/#/?m=' + item.uuid
            } else if (item.type == 2) {
                window.location.href = 'https://conference-h5.dr-gobroad.com/#/live-list?m=' + item.uuid
            }
        }
    },
    initChannel(current){
        if(current == 'live'){
            sessionStorage.removeItem('clinic_course_channel')
            sessionStorage.removeItem('search_channel')
        }else if(current == 'clinic'){
            sessionStorage.removeItem('live_search_channel')
            sessionStorage.removeItem('search_channel')
        }else if(current == 'search'){
            sessionStorage.removeItem('live_search_channel')
            sessionStorage.removeItem('clinic_course_channel')
        }
    },
    mFootPrint( id = 0, type,content_type = 0,page_type, source_type = 0, title) {
        let params = {
            id: id,
            type: type,
            content_type: content_type,
            page_type: page_type,
            source_type: source_type,
            title: title
        }
        this.getData('post', this.footprint, params)
    },
    mShareFootPrint(type,source_type,content_id,title) {
        let params = {
            type: type,
            source_type: source_type,
            content_id: content_id,
            title: title
        }
        this.getData('get', this.shareFootPrintUrl, params)
    },
    shareFootPrint(title,type,id){
        if (type == 36) {
          this.mShareFootPrint(36,1,1, '首页')
        } else if (type == 38) {
            this.mShareFootPrint(38,1,1, '直播主页')
        } else if (type == 39) {
            this.mShareFootPrint(39,1,1, '临床好课主页')
        } else if (type == 40) {
            this.mShareFootPrint(40,1,1, '病例实战主页')
        } else if (type == 41) {
            this.mShareFootPrint(41,1,1, '医学专栏主页')
        } else if (type == 44) {
            this.mShareFootPrint(44,1,1, '荟议日历主页')
        } else if (type == 45) {
            this.mShareFootPrint(45,1,1, '指南共识主页')
        } else if (type == 13) {
            this.mShareFootPrint(13,1,id, '专题页')
        } else if (type == 4) {
            this.mShareFootPrint(4,1,id, title)
        } else if (type == 1) {
            this.mShareFootPrint(1,1,id, title)
        } else if (type == 6) {
            this.mShareFootPrint(6,1,id, title)
        } else if (type == 30) {
            this.mShareFootPrint(30,1,id, title)
        }
    },
    checkComplete(_this){
        let user = localStorage.getItem('user')
        user = JSON.parse(user)
        if (user.is_complete !== 1) {
            _this.$dialog
                .confirm({
                    title: '需要登录',
                    message: '为了方便学习课程,需要您登录认证',
                    confirmButtonText: '去认证'
                })
                .then(() => {
                    sessionStorage.setItem('back-url', _this.$route.path)
                    _this.$router.push({ name: 'login' })
                })
                .catch(() => {
                    // on cancel
                })
            return false
        }
        return true
    },
    getUrl(url) {
      let source_type = 0
      if (url && url.indexOf('?') > -1) {
          let params = url.split('?')[1]
          if (params) {
              let arr = params.split('&')
              for(let i = 0; i < arr.length; i++) {
                  let p = arr[i].split('=')
                  if (p[0] == 'source_type') {
                      source_type = p[1]
                  }
              }
          }
      }
      return source_type
    },
    // 曝光打点
    exposureFootPrint(data) {
       let params = { data: data }
       this.getData('post',this.exposureFootPrintUrl, params)
    },
    // 曝光打点
    pvPrint(id) {
        if(id == 0){
            setTimeout(() => {
                this.getData('post',this.pvPrintUrl, {
                    id:id,
                    title:document.title,
                    path:window.location.href
                }).then(res => {
                    if(res.code == 0){
                        sessionStorage.setItem('PvLastId', res.data.id)
                    }
                })
            },1000)
        }else{
            this.getData('post',this.pvPrintUrl, {id:id,})
            setTimeout(() => {
                this.getData('post',this.pvPrintUrl, {
                    id:0,
                    title:document.title,
                    path:window.location.href
                }).then(res => {
                    if(res.code == 0){
                        sessionStorage.setItem('PvLastId', res.data.id)
                    }
                })
            },1000)
        }
    },
}



// WEBPACK FOOTER //
// ./src/util/interface.js